import { Component } from "@angular/core";
import { SharedImportsModule } from "../../shared/shared-imports.module";

@Component({
  selector: "app-qualified-list",
  standalone: true,
  imports: [SharedImportsModule],
  templateUrl: "./qualified-list.component.html",
})
export class QualifiedListComponent {
  public schools = [
    { schoolAttended: "Aerial Truck School", schoolDivision: "Truck" },
    { schoolAttended: "Basic Truck Ops", schoolDivision: "Truck" },
    { schoolAttended: "Collapse Rescue Technician", schoolDivision: "Rescue" },
    {
      schoolAttended: "Confined Space Rescue Technician",
      schoolDivision: "Rescue",
    },
    { schoolAttended: "Corp. Fire School", schoolDivision: "Fire" },
    { schoolAttended: "Emergency Medical Responder", schoolDivision: "EMR" },
    {
      schoolAttended: "Emergency Medical Technician",
      schoolDivision: "Medical",
    },
    {
      schoolAttended: "Emergency Response Training Specialist Training",
      schoolDivision: "Elective",
    },
    { schoolAttended: "EMR", schoolDivision: "EMR" },
    { schoolAttended: "EMT", schoolDivision: "EMT" },
    { schoolAttended: "ERT", schoolDivision: "ERT" },
    { schoolAttended: "FCE Complete Date", schoolDivision: "New" },
    { schoolAttended: "HAZMAT Technician", schoolDivision: "Hazmat" },
    { schoolAttended: "High Angle Rescue", schoolDivision: "Rescue" },
    {
      schoolAttended: "Industrial Fire Apparatus Class",
      schoolDivision: "Truck",
    },
    {
      schoolAttended: "Mobilizing Equipment Specialist",
      schoolDivision: "MERT",
    },
    { schoolAttended: "NFPA 1081 Exterior Fire", schoolDivision: "Fire" },
    {
      schoolAttended: "Pumper Apparatus Fire Truck Operations",
      schoolDivision: "Truck",
    },
    { schoolAttended: "Rope Rescue Technician", schoolDivision: "Rescue" },
    { schoolAttended: "Trench Rescue 1 and 2", schoolDivision: "Rescue" },
    { schoolAttended: "Trench Rescue Technician", schoolDivision: "Rescue" },
    { schoolAttended: "Truck OPR", schoolDivision: "Truck" },
  ];
}
